module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-radio-group', {
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.updateValue
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('el-radio', {
      key: option.value,
      attrs: {
        "label": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ee1df18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/Radio.vue
// module id = 525
// module chunks = 1